// extracted by mini-css-extract-plugin
module.exports = {"description":"DescribeTransaction_description__WAw84"};